/* HTTP Media repository — multipart upload to the backend (→ MinIO). */
import { apiDelete, apiGet, apiUpload } from './httpClient'
import type { MediaItem } from './types'
import type { AddMediaInput } from './media.mock'

export function listMedia(tripId: string, pointId?: string): Promise<MediaItem[]> {
  const q = pointId ? `?point_id=${pointId}` : ''
  return apiGet<MediaItem[]>(`/trips/${tripId}/media${q}`)
}

export function addMedia(tripId: string, input: AddMediaInput): Promise<MediaItem> {
  const form = new FormData()
  form.append('file', input.file)
  if (input.point_id) form.append('point_id', input.point_id)
  if (input.visibility) form.append('visibility', input.visibility)
  if (input.client_id) form.append('client_id', input.client_id)
  return apiUpload<MediaItem>(`/trips/${tripId}/media`, form)
}

export function deleteMedia(tripId: string, mediaId: string): Promise<void> {
  return apiDelete(`/trips/${tripId}/media/${mediaId}`)
}
